import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Sidebar } from './components/Sidebar';
import { HomeScreen } from './screens/HomeScreen';
import { StudyScreen } from './screens/StudyScreen';
import { ImportingScreen } from './screens/ImportingScreen';
import { PlanRevealScreen } from './screens/PlanRevealScreen';
import { SessionScreen } from './screens/SessionScreen';
import { GraphScreen } from './screens/GraphScreen';
import { StruggleReelScreen } from './screens/StruggleReelScreen';

function Shell({ children }) {
  return (
    <div className="app-shell" style={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar />
      <main className="app-main" style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        {children}
      </main>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Shell>
        <Routes>
          <Route path="/"                    element={<HomeScreen/>}/>
          <Route path="/study"               element={<StudyScreen/>}/>
          <Route path="/importing"           element={<ImportingScreen/>}/>
          <Route path="/plan"                element={<PlanRevealScreen/>}/>
          <Route path="/session"             element={<SessionScreen/>}/>
          <Route path="/graph"               element={<GraphScreen/>}/>
          <Route path="/reel"                element={<StruggleReelScreen/>}/>
          <Route path="/reel/:sessionId"     element={<StruggleReelScreen/>}/>
          <Route path="*"                    element={<Navigate to="/" replace/>}/>
        </Routes>
      </Shell>
    </BrowserRouter>
  );
}
